package org.gstechnovos.jexonplastech.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.gstechnovos.jexonplastech.components.ContactForm
import org.gstechnovos.jexonplastech.components.SectionTitle
import org.gstechnovos.jexonplastech.models.Section
import org.gstechnovos.jexonplastech.util.Constants.LocalBreakpoint
import org.gstechnovos.jexonplastech.util.Constants.SECTION_WIDTH
import org.gstechnovos.jexonplastech.util.ObserveViewportEntered
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun ContactMeSection (){
    Box(
        modifier = Modifier.id(Section.Contact.id)
            .maxWidth(SECTION_WIDTH.px).padding(topBottom = 100.px),
        contentAlignment = Alignment.Center
    ) {
        ContactMeContent()
    }
}

@Composable
fun ContactMeContent(){

    val breakpoint = LocalBreakpoint.current
    val scope = rememberCoroutineScope()
    var animatedRotation by remember { mutableStateOf(0.deg) }

    ObserveViewportEntered(
        sectionId = Section.Contact.id,
        distanceFromTop = 500.0,
        onViewportEntered = {
            animatedRotation = 10.deg
            scope.launch {
                delay(500)
                animatedRotation = 0.deg
            }
        }
    )

    Column(
        modifier = Modifier
            .fillMaxWidth(if (breakpoint >= Breakpoint.MD) 100.percent else 90.percent),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        SectionTitle(
            modifier = Modifier.fillMaxWidth()
                .transform {
                    rotate(animatedRotation)
                }
                .transition {
                    Transition.of(property ="transform",duration= 500.ms)
                    timingFunction(TransitionTimingFunction.EaseInOut)
                }
                .margin(bottom = 25.px),
            section = Section.Contact,
            alignment = Alignment.CenterHorizontally
        )

        ContactForm()
    }
}